<bz-dialog-layout [heading]="(isStatusHistory ? 'Status History' : 'Time-Card Log') | translate" [dismissible]="true">

  <div bzDialogContent class="layout-column timecard-dialog-body history-log-body" appBringozIdGenerator="timecardHistoryLogDialog">

    @if (hasFilterCaption) {
      <div class="br-caption gray-101">
        {{ 'Showing history for' | translate }}:
        @if (data.filterStopName) {
          <strong>{{ data.filterStopName }}</strong>
          @if (data.filterField) { - }
        }
        @if (data.filterField) {
          <strong>{{ 'TIMECARD_HISTORY_LOGS.' + data.filterField | translate }}</strong>
        }
      </div>
    }

    <bz-search-input class="history-log-search"
                     appBringozIdGenerator="historyLogSearchInput"
                     [placeholder]="'Search' | translate"
                     [ariaLabel]="'Search' | translate"
                     [value]="searchQuery()"
                     (valueChange)="searchQuery.set($event)">
    </bz-search-input>

    <bz-table class="history-log-table"
              [uniqueId]="isStatusHistory ? 'timecard-status-history' : 'timecard-history-log'"
              [rowHeight]="40"
              [headerHeight]="40"
              [resizable]="true"
              [defaultWidths]="defaultWidths"
              [items]="filteredRows()">

      <ng-template bzTableHeader>
        <div class="th col-name">{{ 'Timestamp' | translate }}</div>
        @if (isStatusHistory) {
          <div class="th col-statusChange">{{ 'Status Change' | translate }}</div>
          <div class="th col-changedBy">{{ 'Changed By' | translate }}</div>
        } @else {
          <div class="th col-stopName">{{ 'Stop' | translate }}</div>
          <div class="th col-by">{{ 'By' | translate }}</div>
          <div class="th col-userType">{{ 'User Type' | translate }}</div>
          <div class="th col-stopIndex">{{ 'Stop' | translate }}</div>
          <div class="th col-field">{{ 'Field' | translate }}</div>
          <div class="th col-previousState">{{ 'Previous State' | translate }}</div>
          <div class="th col-currentState">{{ 'Current State' | translate }}</div>
          <div class="th col-note">{{ 'Note' | translate }}</div>
        }
      </ng-template>

      <ng-template bzTableRow let-row>
        <!-- bz-table wraps only the header in a .tr; each row brings its own -->
        <div class="tr">
          <div class="td col-name">{{ row | bringozFullDate:'timestamp' }} {{ row | bringozTime:'timestamp' }}</div>

          @if (isStatusHistory) {
            <div class="td col-statusChange layout-row layout-align-start-center">
              <span>{{ 'TIMECARD_SHIFT_STATUS.' + row.previousState | translate }}</span>
              <bz-icon size="sm" class="margin-left-10 margin-right-10" [icon]="icons.arrow"></bz-icon>
              <span>{{ 'TIMECARD_SHIFT_STATUS.' + row.currentState | translate }}</span>
            </div>
            <div class="td col-changedBy text-ellipsis" container="body" [ngbTooltip]="row.updatedBy !== '-' ? row.updatedBy : ''">
              {{ row.updatedBy }}
            </div>
          } @else {
            <div class="td col-stopName text-ellipsis" container="body" [ngbTooltip]="row.stopName !== '-' ? row.stopName : ''">
              {{ row.stopName }}
            </div>
            <div class="td col-by text-ellipsis" container="body" [ngbTooltip]="row.updatedBy !== '-' ? row.updatedBy : ''">
              {{ row.updatedBy }}
            </div>
            <div class="td col-userType">
              <bz-tag [tone]="row.userType === 'Employee' ? 'info' : 'neutral'">{{ row.userType }}</bz-tag>
            </div>
            <div class="td col-stopIndex">{{ row.stopIndex }}</div>
            <div class="td col-field text-ellipsis" container="body" [ngbTooltip]="'TIMECARD_HISTORY_LOGS.' + row.field | translate">
              {{ 'TIMECARD_HISTORY_LOGS.' + row.field | translate }}
            </div>
            <div class="td col-previousState text-ellipsis">
              <ng-container *ngTemplateOutlet="stateValue; context: {$implicit: row, key: 'previousState'}"></ng-container>
            </div>
            <div class="td col-currentState text-ellipsis">
              <ng-container *ngTemplateOutlet="stateValue; context: {$implicit: row, key: 'currentState'}"></ng-container>
            </div>
            <div class="td col-note text-ellipsis" container="body" [ngbTooltip]="row.note">{{ row.note }}</div>
          }
        </div>
      </ng-template>

      <bz-empty-state bzTableEmptyState [title]="'No history records found' | translate"></bz-empty-state>
    </bz-table>
  </div>

  <div bzDialogActions>
    <span></span>
    <bz-button variant="tertiary" appBringozIdGenerator="closeBtn" (clicked)="onCancel()">
      {{ 'Close' | translate }}
    </bz-button>
  </div>

</bz-dialog-layout>

<!-- One formatter for both state columns: each value type has its own pipe -->
<ng-template #stateValue let-row let-key="key">
  @switch (row.valueType) {
    @case ('time') {
      {{ row | bringozTime:key:'---' }}
    }
    @case ('duration') {
      {{ row[key] | bringozTimeConvert:true:false }}
    }
    @case ('distance') {
      {{ row[key] | bringozDistance:'---':true:2 }}
    }
    @default {
      <span container="body" [ngbTooltip]="row[key]">{{ row[key] }}</span>
    }
  }
</ng-template>
